<template>
  <div class="wrapper">
    <p class="title -t2 -center -regular links-title">{{ title }}</p>
    <div class="grid-x grid">
      <div
        v-for="(links, index) in chunkedLinks"
        class="cell small-12 medium-6 links"
        :key="'links:' + index"
      >
        <div v-for="link in links" class="item" :key="'link:' + link.title">
          <p class="title -t4 -regular item-title">{{ link.title }}</p>
          <a v-if="link.link" :href="link.link" class="text -green -t3 -no-wrap" target="_blank">Go to link</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chunk from "@/util/chunk";

export default {
  props: {
    title: String,
    links: Array,
  },
  computed: {
    chunkedLinks() {
      return chunk(this.links, Math.ceil(this.links.length / 2));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
$border: 1px solid #979797;
.wrapper {
  margin: vw-relative(20 0, 320);
  @include breakpoint(medium) {
    margin: vw-relative(40 0);
  }
}
.links-title {
  margin-bottom: 1em;
}
.grid {
  margin: vw-relative(0 -60);
}
.links {
  @include breakpoint(small only) {
    &:last-child {
      margin-top: -1px;
    }
  }
  @include breakpoint(medium) {
    &:first-child {
      border-right: $border;
    }
  }
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: vw-relative(14 0, 320);
  margin: vw-relative(0 60);
  border-bottom: $border;
  &:first-child {
    border-top: $border;
  }
  @include breakpoint(medium) {
    padding: vw-relative(14 0);
  }
}
</style>
